export default function viewType(target: any, prop: string) {

  const NG_ON_ONIT_NAME = 'ngOnInit';

  /** ngOnInit might not be implemented by this component */
  const ngOnInitClone: Function|null = target[NG_ON_ONIT_NAME];

  Object.defineProperty(target, NG_ON_ONIT_NAME, {
    value: function() {
      if (this[prop]) {
        this[prop] = this[prop].toLowerCase();
        if ( ['week' , 'month'].indexOf(this[prop]) === -1 ) {
          console.error(
            target.constructor.name +
            `: ${this[prop]} is not valid View type value\nvalid values: {'week' , 'month'}`
          );
          this[prop] = 'month';
        }
      } else {
        this[prop] = 'month';
      }
      // Calling the original ngOnInit with its original context
      if( ngOnInitClone ) {
        ngOnInitClone.call(this);
      }
    }
  });
}
